/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_NavInputs */

const en_mk_sol_lembaga_nav = /** @type {(inputs: Mk_Sol_Lembaga_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institutions, foundations & NGOs`)
};

const id_mk_sol_lembaga_nav = /** @type {(inputs: Mk_Sol_Lembaga_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembaga, yayasan & organisasi`)
};

/**
* | output |
* | --- |
* | "Institutions, foundations & NGOs" |
*
* @param {Mk_Sol_Lembaga_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_nav = /** @type {((inputs?: Mk_Sol_Lembaga_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_nav(inputs)
	return en_mk_sol_lembaga_nav(inputs)
});